export interface Span {
  id: string;
  parent_id: string;
  session_id: string;
  label: string;
  attributes: {[key: string]: string};
  start_time: number;
  end_time: number;
  platform: string;
}

interface Event {
  id: string;
  span_id: string;
  session_id: string;
  label: string;
  attributes: {[key: string]: string};
  timestamp: number;
  platform: string;
}

interface ApiPayload {
  spans: Span[];
  events: Event[];
}

export interface SpannerInterface {
  set(attributes: {[key: string]: string}): void;
  open(label: string, attributes: {[key: string]: string}, parent_id?: string): string;
  close(spanId: string): void;
  event(spanId: string, label: string, attributes: {[key: string]: string}): void;
}

export class Spanner implements SpannerInterface {

  attributes: { [key: string]: string; } = {};
  spans = new Map<string, Span>();

  constructor(
    private sessionId: string,
    private platform: string,
    private sendSpan: (span: Span) => void,
    private sendEvent: (event: Event) => void,
    private newUUID: () => string,
  ) { }

  set(attributes: { [key: string]: string; }): void {
    Object.assign(this.attributes, attributes);
  }

  open(label: string, attributes: { [key: string]: string; }, parent_id?: string): string {
    const id = this.newUUID();
    const span: Span = {
      id,
      label,
      attributes: {
        ...this.attributes,
        ...attributes,
      },
      start_time: Date.now(),
      end_time: 0,
      session_id: this.sessionId,
      parent_id: parent_id || '',
      platform: this.platform,
    }
    this.spans.set(id, span);
    this.sendSpan(span);

    return id;
  }

  close(spanId: string): void {
    const span = this.spans.get(spanId);
    if(!span) return console.error('Unknown span', spanId);
    if(span.end_time) return console.error(`Span ${span.label} already closed`, spanId);

    span.end_time = Date.now();
    this.sendSpan(span);
  }

  event(spanId: string, label: string, attributes: { [key: string]: string; }): void {
    const event: Event = {
      id: this.newUUID(),
      span_id: spanId,
      attributes: {
        ...this.attributes,
        ...attributes,
      },
      label,
      session_id: this.sessionId,
      timestamp: Date.now(),
      platform: this.platform,
    }
    this.sendEvent(event);
  }

}


export async function sendData(payload: ApiPayload) {
  const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
  navigator.sendBeacon('/log-data', blob);
}